// QuickActionCard.jsx
import React from 'react';

const QuickActionCard = ({ icon: Icon, label, description, color, action }) => {
  const colors = {
    blue: 'hover:border-blue-300 hover:bg-blue-50 group-hover:text-blue-600',
    emerald: 'hover:border-emerald-300 hover:bg-emerald-50 group-hover:text-emerald-600',
    indigo: 'hover:border-indigo-300 hover:bg-indigo-50 group-hover:text-indigo-600',
    orange: 'hover:border-orange-300 hover:bg-orange-50 group-hover:text-orange-600'
  };

  return (
    <button 
      onClick={action} 
      className={`group text-left p-3 rounded-xl border border-slate-200 bg-slate-50/30 transition-all duration-200 hover:shadow-md ${colors[color]}`}
    >
      <div className="mb-2">
        <Icon className="w-5 h-5 text-slate-400 group-hover:scale-110 transition-transform duration-200" />
      </div>
      <div className="font-semibold text-slate-700 text-sm">{label}</div>
      <div className="text-[10px] text-slate-400 mt-0.5">{description}</div>
    </button>
  );
};

export default QuickActionCard;